<p-dialog [(visible)]="showInvoiceDetail" [style]="{ width: '400px' }" [appendTo]="'body'" [baseZIndex]="10000">
    <ng-template pTemplate="header">
        <div class="flex justify-content-between align-items-center">
            <h5>Factuur</h5>
        </div>
    </ng-template>
    <ng-template pTemplate="content">
        <div class="flex flex-column align-items-center">
            <img src="/icons/invoices-green-icon.png" alt="Invoice Icon" class="icon-smaller mb-2" />
            <h5>{{ InvoiceType[invoice.invoiceType] }} {{ invoice.invoiceDate | date: 'MMMM yyyy' }}</h5>
            <p>Datum: {{ invoice?.invoiceDate | date: 'dd/MM/yyyy' }}</p>
            <p>Bedrag: {{ invoice?.amount | currency: 'EUR' }}</p>
            <p>Openstaand saldo: {{ invoice.outstandingAmount | currency: 'EUR' }}</p>
            <p>Factuurnummer: {{ invoice.documentNumber }}</p>
            <p>Factuurdatum: {{ invoice.invoiceDate | date: 'dd/MM/yyyy' }}</p>
            <p><p-tag [severity]="getInvoiceStatusClass(getInvoiceStatus(invoice))">{{ getInvoiceStatus(invoice) }}</p-tag></p>
        </div>
    </ng-template>

</p-dialog>